export const ERROR_CATEGORIES = {
  Network: 'network',
  Auth: 'auth',
  Access: 'access',
  Validation: 'validation',
  NotFound: 'not_found',
  Conflict: 'conflict',
  RateLimit: 'rate_limit',
  Server: 'server',
  Unknown: 'unknown',
};

export const ERROR_CODES = {
  NETWORK_OFFLINE: 'NETWORK_OFFLINE',
  NETWORK_TIMEOUT: 'NETWORK_TIMEOUT',
  AUTH_UNAUTHENTICATED: 'AUTH_UNAUTHENTICATED',
  AUTH_EXPIRED: 'AUTH_EXPIRED',
  ACCESS_FORBIDDEN: 'ACCESS_FORBIDDEN',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  RATE_LIMIT: 'RATE_LIMIT',
  SERVER_ERROR: 'SERVER_ERROR',
  UNKNOWN: 'UNKNOWN',
};

export const ERROR_COPY = {
  [ERROR_CODES.NETWORK_OFFLINE]:
    'No internet connection detected. Please check your network and try again.',
  [ERROR_CODES.NETWORK_TIMEOUT]:
    'The request is taking longer than expected. Please try again in a moment.',
  [ERROR_CODES.AUTH_UNAUTHENTICATED]:
    'Your session has ended. Please log in to continue.',
  [ERROR_CODES.AUTH_EXPIRED]:
    'Your session has expired. Log in again to refresh access.',
  [ERROR_CODES.ACCESS_FORBIDDEN]:
    "You don't have permission to access this resource.",
  [ERROR_CODES.VALIDATION_FAILED]:
    'Some information needs your attention before we can continue.',
  [ERROR_CODES.NOT_FOUND]: 'We could not find what you were looking for.',
  [ERROR_CODES.CONFLICT]:
    'That action could not be completed because data changed. Please refresh and try again.',
  [ERROR_CODES.RATE_LIMIT]:
    'Too many requests. Please wait a moment and try again.',
  [ERROR_CODES.SERVER_ERROR]:
    'Something went wrong on our side. Please try again shortly.',
  [ERROR_CODES.UNKNOWN]: 'An unexpected error occurred. Please try again.',
};

export const UX_HINTS = {
  RETRY: 'retry',
  REDIRECT_LOGIN: 'redirect_login',
  CONTACT_SUPPORT: 'contact_support',
  REFRESH: 'refresh',
  NONE: 'none',
};
